<template>
  <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
        <h1>DPP</h1>
          <div class="container-form">
            <div class="section">
                <div class="form-label mg-top1">DPP Profile</div>
                <input id="assetUpload" type="file" accept="image/*" @change="onAddFile($event)" hidden> 
                <div class="mg-top1">
                    <img class="imgUpload" v-if="assetImgUrl" :src="assetImgUrl" alt="">
                    <button class="btn-upload mg-top1 mg-right" @click="chooseFiles()">Choose</button>
                </div>
                <div class="wrapper mg-top1">
                    <div class="input-data">
                        <input type="text" required v-model="name">
                        <div class="underline"></div>
                        <label>Name</label>
                    </div>
                    <div class="text-area mg-top">
                        <textarea name="" id="" required v-model="description"></textarea>
                        <div class="underline"></div>
                        <label>Description</label>
                    </div>
                    <div class="input-data mg-top">
                        <input type="text" required v-model="ketua">
                        <div class="underline"></div>
                        <label>Ketua</label>
                    </div>
                    <div class="input-data mg-top">
                        <input type="text" required v-model="sekretaris">
                        <div class="underline"></div>
                        <label>Sekretaris</label>
                    </div>
                    <div class="input-data mg-top">
                        <input type="text" required v-model="bendahara">
                        <div class="underline"></div>
                        <label>Bendahara</label>
                    </div>
                    <div class="input-data mg-top">
                        <input type="text" required v-model="email">
                        <div class="underline"></div>
                        <label>Email</label>
                    </div>
                    <div class="text-area mg-top">
                        <textarea name="" id="" required v-model="alamat"></textarea>
                        <div class="underline"></div>
                        <label>Alamat</label>
                    </div>
                     <div class="input-data mg-top">
                        <input type="text" required v-model="website">
                        <div class="underline"></div>
                        <label>Website</label>
                    </div>
                    <div class="input-data mg-top">
                        <input type="text" required v-model="latitude">
                        <div class="underline"></div>
                        <label>Latitude</label>
                        </div>
                    <div class="input-data mg-top">
                        <input type="text" required v-model="longitude">
                        <div class="underline"></div>
                        <label>Longitude</label>
                    </div>
                </div>
                <div class="btn-heading">
                    <p class="mg-top" v-if="errors.length">
                        <b>Please correct the following error(s):</b>
                        <ul>
                            <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                        </ul>
                    </p>

                    <button v-if="dpp_id != 0" class="hov-del btn-add mg-right" @click="delData()">
                      Delete DPP
                    </button>
                    <button class="btn-add mg-top1" @click="validation(dpp_id != 0 ? 'update' : 'add')">
                        {{dpp_id ? 'Update' : 'Add'}} DPP
                    </button>
                </div>
            </div>
          </div>
    </div>
  </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';

import auth from '@/service/auth.js'

export default {
  name: 'Home',
  data() {
    return {
        isLoading: false,
        isPlaying: false,

        dpp_id: '',
        assetImage: null,
        assetImgUrl : null,
        name: '',
        description: '',
        ketua: '',
        sekretaris: '',
        bendahara: '',
        alamat: '',
        email: '',
        website: '',
        latitude: '',
        longitude: '',
        errors: []
    }
  },
  methods: {
    validation(type) {
      this.errors = []

       if (type === 'add') {
         if (!this.name) this.errors.push('* Name cannot be empty')
         if (!this.ketua) this.errors.push('* Ketua Name required')
         if (!this.sekretaris) this.errors.push('* Sekretaris Name required')
         if (!this.bendahara) this.errors.push('* Bendahara Name required')
         if (!this.alamat) this.errors.push('* Enter valid address')
         if (!this.latitude) this.errors.push('* Enter valid latitude')
         if (!this.longitude) this.errors.push('* Enter valid longtitude')
       }
      

      if (this.errors.length > 0) {
          return
      } else if (type === 'add') {
          this.addDpp()
      } else if (type === 'update') {
          this.updateDpp()
      }
    },
    onAddFile (e) {
         this.assetImage = e.target.files[0]
            this.assetImgUrl = URL.createObjectURL(this.assetImage)
            console.log('asset', this.assetImage)
            console.log('assetUrl', this.assetImgUrl)
    },
    chooseFiles() {
        document.getElementById("assetUpload").click()
    },
    async getData () {
      this.isLoading = true
      try {
        const response = await axios.get('/member/dpp')
        console.log(response)

        let data = response.data

        // this.listData = data
        this.assetImage = data.dpp_foto.String
        this.assetImgUrl = data.dpp_foto.String
        this.dpp_id = data.dpp_id
        this.name = data.dpp_name
        this.description = data.dpp_description.String
        this.ketua = data.dpp_ketua
        this.sekretaris = data.dpp_sekretaris
        this.bendahara = data.dpp_bendahara
        this.email = data.dpp_email.String
        this.website = data.dpp_website.String
        this.alamat = data.dpp_alamat
        this.latitude = data.dpp_latitude
        this.longitude = data.dpp_longitude
        this.isLoading = false
          
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async addDpp() {
      const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
          localStorage.clear()
          alert.failed('Unauthorized Token', () => this.$router.push('/login'))
      } else {
        try {
            this.isLoading = true
            const formData = new FormData()
            
            // let date = moment(this.date).format()

            formData.append('asset', this.assetImage)
            formData.append('dpp_name', this.name)
            formData.append('dpp_foto', this.assetImage)
            formData.append('dpp_description', this.description)
            formData.append('dpp_ketua', this.ketua)
            formData.append('dpp_sekretaris', this.sekretaris)
            formData.append('dpp_bendahara', this.bendahara)
            formData.append('dpp_alamat', this.alamat)
            formData.append('dpp_email', this.email)
            formData.append('dpp_website', this.website)
            formData.append('dpp_website', this.website)
            formData.append('dpp_latitude', this.latitude)
            formData.append('dpp_longitude', this.longitude)

            const response = await axios.post('/member/dpp', formData)
            this.isLoading = false

            console.log(response)
            if(response.status == 201) {
                alert.success('Add data success')
            }
        } catch (error) {
            console.log(error)
            alert.failed('Add data failed')
        }
      }
    },
    async updateDpp() {
      const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
          localStorage.clear()
          alert.failed('Unauthorized Token', () => this.$router.push('/login'))
      } else {
        try {
            this.isLoading = true
            const formData = new FormData()
            
            // let date = moment(this.date).format()

            formData.append('dpp_foto', this.assetImage)
            formData.append('dpp_name', this.name)
            formData.append('dpp_description', this.description ? this.description : ' ')
            formData.append('dpp_ketua', this.ketua)
            formData.append('dpp_sekretaris', this.sekretaris)
            formData.append('dpp_bendahara', this.bendahara)
            formData.append('dpp_alamat', this.alamat)
            formData.append('dpp_email', this.email)
            formData.append('dpp_website', this.website)
            formData.append('dpp_website', this.website)
            formData.append('dpp_latitude', this.latitude)
            formData.append('dpp_longitude', this.longitude)

            const response = await axios.patch('/member/dpp', formData)
            this.isLoading = false

            console.log(response)
            if(response.status == 200) {
                alert.success('Add data success')
            }
        } catch (error) {
            console.log(error)
            alert.failed('Add data failed')
        }
      }
    },
    async delData() {
        let self = this
        alert.confirmation( async function () {
        self.isLoading = true
        try {
          const response = await axios.delete(`/member/dpp`)
          self.isLoading = false
          console.log(response)
          // self.getBanner(type)
          alert.success('Delete data success', () => self.resetData())
        } catch (error) {
          self.isLoading = false
          console.log(error)
          alert.failed('Delete data failed')
        }
      }, 'Are you sure to delete it?')
    },
    resetData() {
        this.dpp_id = ''
        this.assetImage = ''
        this.assetImgUrl = ''
        this.name = ''
        this.description = ''
        this.ketua = ''
        this.sekretaris = ''
        this.bendahara = ''
        this.email = ''
        this.website = ''
        this.alamat = ''
        this.latitude = ''
        this.longitude = ''
    }
  },
  components: {
    Loader
  },
  async created () {
    const res = await auth.checkAuth(this.$route.fullPath)
    if (res == false) {
      localStorage.clear()
      this.$router.push('/login')  
    }
    this.getData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
